
namespace Sintra {

	// const WizardGroupHeaderStyle = document.createElement("style");
	// WizardGroupHeaderStyle.innerHTML = `
	// 	.wizard-group-header {
	// 		margin: 0;
	// 		padding: 5px;
	// 		color: #E9EAEA;
	// 		cursor: default;
	// 		position: relative;
	// 	}
	// 	.wizard-group-header[data-visited="true"] {
	// 		cursor: pointer;
	// 	}
	// 	.wizard-group-header.active {
	// 		cursor: default;
	// 		font-weight: bold;
	// 		color: #003165;
	// 	}
	// 	.wizard-group-header > .header {
	// 		padding: 0 20px;
	// 	}
	// 	.wizard-group-header[data-visited="true"] > .header {
	// 		color: #003165;
	// 	}
	// 	.wizard-group-header [template-part="index"] {
	// 		font-size: 14px;
	// 		line-height: 20px;
	// 	}
	// 	.wizard-group-header [template-part="text"] {
	// 		font-size: 14px;
	// 		line-height: 20px;
	// 	}
	// 	.wizard-group-header [template-part="line"] {
	// 		height: 8px;
	// 		border-radius: 100vW;
	// 		background: currentColor;
	// 		margin-top: 4px;
	// 	}`;	
	//document.head.appendChild(WizardGroupHeaderStyle);

	const WizardGroupHeaderTemplate = document.createElement("template");
	WizardGroupHeaderTemplate.innerHTML = /*html*/ `
		<div class="header">
			<span template-part="text"></span>
		</div>
	`;

	export class WizardGroupHeader extends WebComponent {

		private _groupNumber: number;
		private _groupName: string;
		private _isActive: boolean;
		private _isVisited: boolean;
		private _target: string;
		private _indexElement: HTMLElement;
		private _textElement: HTMLElement;

		constructor(templateSource?: TemplateSource) {
			super("div", templateSource || WizardGroupHeaderTemplate);
			this.visited = false;
			this.htmlElement.classList.add("wizard-group-header");
			this.htmlElement.addEventListener("click", this._onClick.bind(this));
		}

		protected onApplyTemplate(templateRoot: HTMLElement) {
			this._indexElement = this.getTemplatePart("index");
			this._textElement = this.getTemplatePart("text");
			this._setGroupNameProperty(this._groupName);
			this._setGroupNumberProperty(this._groupNumber);
		}


		private _setGroupNameProperty(value: string) {
			if (!this._textElement) {
				return;
			}
			if (value === undefined) {
				this._textElement.innerHTML = "";
				this.htmlElement.removeAttribute("data-group-name");
			}
			else {
				this._textElement.innerText = value;
				this.htmlElement.dataset.groupName = value;
			}
		}

		private _setGroupNumberProperty(value: number) {
			if (!this._indexElement) {
				return;
			}
			if (value === undefined) {
				this._indexElement.innerHTML = "";
			}
			else {
				this._indexElement.innerText = value.toString();
			}
		}

		

		private _onClick(e: Event) {
			e.stopPropagation();
			if (this._isActive || !this._isVisited) {
				return;
			}
			this.htmlElement.dispatchEvent(new CustomEvent("group-click", {
				detail: { 
					sender: this,
					index: this._groupNumber,
					groupName: this._groupName,
					target: this._target
				}
			}));
		}

		public get groupNumber() { return this._groupNumber; }
		public set groupNumber(v: number) { 
			if (this._groupNumber !== v) {
				this._groupNumber = v;
				this._setGroupNumberProperty(v);
			}
		}

		public get groupName() { return this._groupName; }
		public set groupName(v: string) { 
			if (this._groupName !== v) {
				this._groupName = v;
				this._setGroupNameProperty(v);
			}
		}

		public get isActive() { return this._isActive; }
		public set isActive(v: boolean) { 
			if (this._isActive !== !!v) {
				this._isActive = !!v;
				if (this._isActive) {
					this.htmlElement.classList.add("active");
				}
				else {
					this.htmlElement.classList.remove("active");
				}
			}
		}

		public get isVisited() { return this._isVisited; }
		public set isVisited(v: boolean) { 
			if (this._isVisited !== !!v) {
				this._isVisited = !!v;
				if (this._isVisited) {
					this.htmlElement.dataset.visited = "true";
				}
				else {
					this.htmlElement.removeAttribute("data-visited");
				}
			}
		}

		public get target() { return this._target; }
		public set target(v: string) { this._target = v; }

		public visited: boolean;
	}
}